import { Container, Row, Col } from "react-bootstrap";
import { FaLinkedin, FaFacebook, FaInstagram, FaGithub } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-light py-5 mt-5" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
      <Container fluid className="px-5">
        <Row className="align-items-center">
          {/* Logo & Name */}
          <Col md={4} className="text-center text-md-start mb-4 mb-md-0">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <div>
                <h5 className="mb-1 fw-bold">Tariq Mehmood</h5>
                <small className="">Web Developer</small>
              </div>
            </div>
          </Col>

          {/* Navigation Links */}
          <Col md={4} className="text-center mb-4 mb-md-0">
            <div className="d-flex justify-content-center gap-4">
              <a href="#about" className="text-light text-decoration-none">About</a>
              <a href="#projects" className="text-light text-decoration-none">Projects</a>
              <a href="#contact" className="text-light text-decoration-none">Contact</a>
            </div>
             <p className="mb-0 small ">
              © {new Date().getFullYear()} Tariq Mehmood. All Rights Reserved.
            </p>
          </Col>
          {/* Social Icons */}
          <Col md={4} className="text-center text-md-end">
            <div className="mb-3">
              <a href="https://www.linkedin.com/in/tariq-mehmood-b31582387/" className="me-3 text-light fs-4 footer-icon"><FaLinkedin /></a>
              <a href="https://web.facebook.com/tariq.mehmood.731663" className="me-3 text-light fs-4 footer-icon"><FaFacebook /></a>
              <a href="https://www.instagram.com/tariqmeh.mood/" className="me-3 text-light fs-4 footer-icon"><FaInstagram /></a>
              <a href="https://github.com/" className="text-light fs-4 footer-icon"><FaGithub /></a>
            </div>
           
          </Col>
        </Row>
      </Container>

      {/* Extra Styling */}
      <style>
        {`
          .footer-icon {
            transition: color 0.3s ease;
          }
          .footer-icon:hover {
            color: #0d6efd; /* Bootstrap primary blue */
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
